import { useEffect, useState } from 'react';

interface ShareModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
}

const channels = [
  { key: 'weibo', label: '微博', icon: 'ri-weibo-fill' },
  { key: 'wechat', label: '微信', icon: 'ri-wechat-fill' },
  { key: 'link', label: '复制链接', icon: 'ri-link' },
  { key: 'more', label: '更多', icon: 'ri-more-fill' },
];

export default function ShareModal({ open, title, onClose }: ShareModalProps) {
  const [toast, setToast] = useState('');

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => setToast(''), 1800);
    return () => clearTimeout(timer);
  }, [toast]);

  useEffect(() => {
    if (open) setToast('');
  }, [open]);

  if (!open) return null;

  const handleShare = (label: string) => {
    setToast(`已模拟分享《${title}》到${label}（演示功能）`);
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center px-0 sm:px-4">
      <button
        type="button"
        aria-label="关闭分享"
        onClick={onClose}
        className="absolute inset-0 bg-primary-950/50 backdrop-blur-sm cursor-pointer"
      />
      <div className="relative w-full sm:max-w-md bg-background-50 rounded-t-2xl sm:rounded-lg border border-background-200 p-6 animate-fade-up">
        <div className="flex items-center justify-between mb-1">
          <h3 className="font-heading text-lg font-bold text-foreground-950">分享影片</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-500 hover:bg-background-100 cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>
        <p className="text-sm text-foreground-500 mb-5">《{title}》· 分享到社交平台</p>

        <div className="grid grid-cols-4 gap-3">
          {channels.map((c) => (
            <button
              key={c.key}
              type="button"
              onClick={() => handleShare(c.label)}
              className="flex flex-col items-center gap-2 py-3 rounded-lg bg-background-100 border border-background-200 hover:border-accent-300 hover:bg-accent-50 transition-colors cursor-pointer"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-700 text-accent-300 text-xl">
                <i className={c.icon}></i>
              </span>
              <span className="text-xs text-foreground-700">{c.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-5 flex items-center gap-2 text-xs text-foreground-500 bg-secondary-50 border border-secondary-200 rounded-md px-3 py-2.5">
          <i className="ri-information-line text-secondary-600"></i>
          本分享为前端模拟演示，不接入任何真实社交平台接口。
        </div>

        {toast && (
          <div className="mt-3 text-xs text-accent-800 bg-accent-100 border border-accent-200 rounded-md px-3 py-2.5 animate-fade-in">
            {toast}
          </div>
        )}
      </div>
    </div>
  );
}